import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    marginTop: SPACES.xxxxxl,
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xs,

    [theme.breakpoints.down('tablet')]: {
      textAlign: 'left',
    },
    [theme.breakpoints.up('tablet')]: {
      paddingLeft: SPACES.xs,
    },
  },
  dateText: {
    '&&': {
      color: theme.palette.custom.grey2,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,
    },
  },
  timeText: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,
      // fontWeight: FONTS.WEIGHTS.medium,
    },
  },
}))
